// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import App from './App'
import router from './router'
import store from './store'

Vue.config.productionTip = false;


//绑定axios拦截器
// import axios from './axios'

// Vue.prototype.$http = axios;




//全局组件
import "./api/registering_components"

//过滤器
import "./api/filter/filter"

router.beforeEach((to,from,next)=>{
    if(to.path=="/login"){
        localStorage.removeItem("_token");
        localStorage.removeItem("user_info")
        next();
    }else{
        if(localStorage.getItem("_token")|| to.path.indexOf("about")>-1){
            next()
        }else{
            next({path:'/login'})
        }
    }
    
})
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App},
    methods: {
        changeInit() {
            window.scrollTo(0, 0);
        }
    },
    watch: {
        "$route": 'changeInit',
    },
    mounted() {

    }

});




// WEBPACK FOOTER //
// ./src/main.js